export const LEAD_ACTION_GET_LEAD_SCHEME_LIST = 'LEAD_ACTION_GET_LEAD_SCHEME_LIST'
export const LEAD_SET_FETCHING_LEAD_SCHEME_LIST = 'LEAD_SET_FETCHING_LEAD_SCHEME_LIST'
export const LEAD_SET_LEAD_SCHEME_LIST = 'LEAD_SET_LEAD_SCHEME_LIST'
